import { requestV3 } from 'Features/Auth/axios-client'
import { useMutation, useQuery, UseQueryResult } from '@tanstack/react-query'
import {
  BaseSourceSiteWorkCentre,
  PreferredMethod,
} from 'Features/Projects/Scenarios/Templates/PlanTemplateSummary.types'

const fetchBaseSourceSiteWorkCentre = async (
  projectId: string,
  scenarioId: string
) => {
  const { data } = await requestV3({
    url: `base-source-site-workcentre?projectId=${projectId}&scenarioId=${scenarioId}`,
  })
  return data
}

export const useBaseSourceSiteWorkCentre = ({
  projectId,
  scenarioId,
}: {
  projectId: string
  scenarioId: string
}): UseQueryResult<BaseSourceSiteWorkCentre[]> => {
  return useQuery({
    queryKey: ['base-source-site-workcentre', projectId, scenarioId],
    queryFn: () => fetchBaseSourceSiteWorkCentre(projectId, scenarioId),
    select: (data) => data.data,
    refetchOnWindowFocus: false,
    gcTime: Infinity,
  })
}

const updateTemplateGeneration = async ({
  projectId,
  scenarioId,
  state,
}: {
  projectId: string
  scenarioId: string
  state: BaseSourceSiteWorkCentre[]
}) => {
  const { data } = await requestV3({
    url: `/updateTemplateGeneration`,
    method: 'POST',
    data: {
      projectId,
      scenarioId,
      state,
    },
  })
  return data
}

export const useUpdateTemplateGeneration = (
  onSuccess: () => void,
  onError: () => void
) => {
  return useMutation({
    mutationFn: updateTemplateGeneration,
    onSuccess,
    onError,
  })
}

export type GenerateParams = {
  projectId: string
  scenarioId: string
  modeInputs: {
    workcentreId: number
    templateMethod: PreferredMethod
  }[]
}

const generateTemplates = async (generateParams: GenerateParams) => {
  const { data } = await requestV3({
    url: `/generate-templates`,
    method: 'PUT',
    data: generateParams,
  })
  return data
}

export const useGenerateTemplates = (
  onSuccess: () => void,
  onError: () => void
) => {
  return useMutation({
    mutationFn: generateTemplates,
    onSuccess,
    onError,
  })
}
